module.exports = __webpack_public_path__ + "img/Dashboard.722f1b62.svg";